import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Activity, Ticket, UtensilsCrossed, Car, CalendarDays } from 'lucide-react';
import { useSettings } from '../../context/SettingsContext';

/**
 * Sticky horizontal module tab strip shown ONLY on mobile, right under the navbar.
 * Lets the user see/switch which module they're searching. Auto-hides modules
 * disabled in Admin. Desktop keeps the navbar tabs (this is md:hidden).
 */
const MobileModuleTabs = () => {
  const loc = useLocation();
  const mods = useSettings()?.modules || {};

  const tabs = [
    { to: '/live-train-status', label: 'Live', icon: Activity, key: 'live_status' },
    { to: '/pnr-status', label: 'PNR', icon: Ticket, key: 'pnr_status' },
    { to: '/trains', label: 'Trains', icon: CalendarDays, key: 'train_tools' },
    { to: '/food-on-train', label: 'Food', icon: UtensilsCrossed, key: 'food_on_train' },
    { to: '/cabs', label: 'Cabs', icon: Car, key: 'cab_booking' },
  ].filter((t) => mods[t.key] !== false);

  if (!tabs.length) return null;
  const isActive = (to) => loc.pathname === to || loc.pathname.startsWith(to);

  return (
    <div className="md:hidden sticky top-16 z-40 bg-white/95 backdrop-blur border-b border-tp-violet/10" data-testid="mobile-module-tabs">
      <div className="flex">
        {tabs.map((t) => {
          const active = isActive(t.to);
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`mtab-${t.key}`}
              className={`flex-1 flex flex-col items-center gap-0.5 py-2.5 relative transition-colors ${
                active ? 'text-tp-violet-deep' : 'text-gray-500'
              }`}
            >
              <t.icon size={18} />
              <span className="text-[11px] font-bold">{t.label}</span>
              {active && <span className="absolute bottom-0 inset-x-3 h-0.5 rounded-full bg-gradient-violet" />}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileModuleTabs;
